import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../../customer/index.js";
const getKeyValuePairs = (entries, filterKeys) => {
    return Object.entries(entries)
        .map(([key, value]) => ({
        key,
        value,
    }))
        .filter(({ key, value }) => filterKeys.includes(key) && value);
};
export const getContractItemMetaFields = (meta) => {
    const contractItemMetaKeys = Object.values(SUBSCRIPTION_CONTRACT_META_KEY);
    return getKeyValuePairs(meta, contractItemMetaKeys);
};
export const getContractMetaFields = (meta) => {
    const contractMetaKeys = Object.values(SUBSCRIPTION_CONTRACT_META_KEY);
    return getKeyValuePairs(meta, contractMetaKeys);
};
export const getCustomerExternalReferences = (meta) => {
    const customerExternalReferenceKeys = Object.values(CUSTOMER_EXTERNAL_REFERENCE_KEY);
    return getKeyValuePairs(meta, customerExternalReferenceKeys);
};
export const getContractInitialSku = (contract) => {
    return contract.meta?.find(({ key }) => key === SUBSCRIPTION_CONTRACT_META_KEY.INITIAL_SKU)?.value;
};
export const getContractSelectedGifts = (contract) => {
    return contract.meta
        ?.find(({ key }) => key === SUBSCRIPTION_CONTRACT_META_KEY.GIFTS)
        ?.value?.split(",");
};
